//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'fullAmount',
  data: function data() {
    return {
      tableData: []
    };
  }
};